import type { Season } from './enums.ts';

/**
 * Calendar-month → season mapping for the homeowner's locale (Southern
 * NH, USA). Dec/Jan/Feb winter, Mar/Apr/May spring, Jun/Jul/Aug summer,
 * Sep/Oct/Nov fall. Returns `'any'` should never happen — the function
 * is total over months 0–11.
 */
export function currentSeason(date: Date = new Date()): Exclude<Season, 'any'> {
  const m = date.getMonth();
  if (m === 11 || m <= 1) return 'winter';
  if (m <= 4) return 'spring';
  if (m <= 7) return 'summer';
  return 'fall';
}

export function currentYear(date: Date = new Date()): number {
  return date.getFullYear();
}

/**
 * Human label for the current period, e.g. "Spring 2027". Used in the
 * dashboard header.
 */
export function currentSeasonLabel(date: Date = new Date()): string {
  const s = currentSeason(date);
  return `${s.charAt(0).toUpperCase()}${s.slice(1)} ${currentYear(date)}`;
}
